export default {
  // Same IP User Warning
  'riskDimension.ip.title': 'Same IP User Warning',
  'riskDimension.ip.ipAddress': 'IP Address',
  'riskDimension.ip.ipAddressPlaceholder': 'Enter IP address',
  'riskDimension.ip.memberAccount': 'Username',
  'riskDimension.ip.memberAccountPlaceholder': 'Enter username',
  'riskDimension.ip.minMemberCount': 'Min Associated Count ≥',
  'riskDimension.ip.minMemberCountPlaceholder': 'Enter',
  'riskDimension.ip.minRiskCount': 'Min Risk Count ≥',
  'riskDimension.ip.minRiskCountPlaceholder': 'Enter',
  'riskDimension.ip.query': 'Search',
  'riskDimension.ip.reset': 'Reset',
  'riskDimension.ip.export': 'Export',
  
  // Table Columns
  'riskDimension.ip.table.ipAddress': 'IP Address',
  'riskDimension.ip.table.totalMembers': 'Total Members',
  'riskDimension.ip.table.riskMembers': 'Risk Members',
  'riskDimension.ip.table.details': 'Details',
  'riskDimension.ip.table.lastUpdateTime': 'Last Update',
  'riskDimension.ip.table.action': 'Action',
  'riskDimension.ip.table.view': 'View',
  'riskDimension.ip.table.expand': 'Expand',
  'riskDimension.ip.table.more': 'More',
  'riskDimension.ip.table.total': 'Total {total} records',
  
  // Quick View Modal
  'riskDimension.ip.quickView.title': 'Associated Users',
  'riskDimension.ip.quickView.ipLabel': 'IP Address',
  'riskDimension.ip.quickView.searchPlaceholder': 'Search account',
  'riskDimension.ip.quickView.noResults': 'No accounts found',
  'riskDimension.ip.quickView.showing': 'Showing',
  
  // Detail Modal
  'riskDimension.ip.detail.title': 'IP Address',
  'riskDimension.ip.detail.summary': 'Total {total} users, {risk} with risk control',
  'riskDimension.ip.detail.batchSetRisk': 'Batch Set Risk Level',
  'riskDimension.ip.detail.searchPlaceholder': 'Search username',
  'riskDimension.ip.detail.search': 'Search',
  'riskDimension.ip.detail.select': 'Select',
  'riskDimension.ip.detail.memberAccount': 'Username',
  'riskDimension.ip.detail.currentRisk': 'Current Risk',
  'riskDimension.ip.detail.setRiskLevel': 'Set Risk Level',
  'riskDimension.ip.detail.batchSetPending': 'Batch set risk level pending',
  
  // Risk Levels
  'riskDimension.riskLevel.limitLogin': 'Limit Login',
  'riskDimension.riskLevel.limitDeposits': 'Limit Deposits',
  'riskDimension.riskLevel.limitWithdrawal': 'Limit Withdrawal',
  'riskDimension.riskLevel.limitDiscount': 'Limit Discount',
  'riskDimension.riskLevel.potentialRisk': 'Potential Risk',
  'riskDimension.riskLevel.sameIp': 'Same IP Risk',
  'riskDimension.riskLevel.sameDevice': 'Same Device Risk',
  'riskDimension.riskLevel.sameBankCard': 'Same Bank Card Risk',
  'riskDimension.riskLevel.sameWallet': 'Same Wallet Risk',
  
  // Set Risk Level Modal
  'riskDimension.setRisk.title': 'Set Risk Level',
  'riskDimension.setRisk.batchTitle': 'Batch Set Risk Level',
  'riskDimension.setRisk.members': 'members',
  'riskDimension.setRisk.riskLevel': 'Risk Level',
  'riskDimension.setRisk.selectPlaceholder': 'Select risk level',
  'riskDimension.setRisk.loginLimitType': 'Login Limit Type',
  'riskDimension.setRisk.loginLimitTypePlaceholder': 'Select login limit type',
  'riskDimension.setRisk.loginLimitTypeRequired': 'Please select login limit type',
  'riskDimension.setRisk.remark': 'Remark',
  'riskDimension.setRisk.remarkPlaceholder': 'Enter remark',
  'riskDimension.setRisk.confirm': 'Confirm',
  'riskDimension.setRisk.cancel': 'Cancel',
  'riskDimension.setRisk.success': 'Risk level set successfully',
  'riskDimension.setRisk.batchSuccess': 'Batch set successfully, updated {count} members',
  'riskDimension.setRisk.error': 'Failed to set risk level',
  'riskDimension.setRisk.missingMemberId': 'Missing member ID',
  
  // Detail Modal
  'riskDimension.ip.detail.selectMembersFirst': 'Please select members first',
  
  // Messages
  'riskDimension.message.queryFailed': 'Query failed',
  'riskDimension.message.queryMemberListFailed': 'Failed to query member list',
  'riskDimension.message.exportLoading': 'Creating export task, please wait...',
  'riskDimension.message.exportSuccess': 'Export task created successfully. Please check the download list.',
  'riskDimension.message.exportFailed': 'Export failed',
  
  // Same Device User Warning
  'riskDimension.device.title': 'Same Device User Warning',
  'riskDimension.device.deviceId': 'Device ID',
  'riskDimension.device.deviceIdPlaceholder': 'Enter device ID',
  'riskDimension.device.memberAccount': 'Username',
  'riskDimension.device.memberAccountPlaceholder': 'Enter username',
  'riskDimension.device.minMemberCount': 'Min Associated Count ≥',
  'riskDimension.device.minMemberCountPlaceholder': 'Enter',
  'riskDimension.device.minRiskCount': 'Min Risk Count ≥',
  'riskDimension.device.minRiskCountPlaceholder': 'Enter',
  'riskDimension.device.query': 'Search',
  'riskDimension.device.reset': 'Reset',
  'riskDimension.device.export': 'Export',
  'riskDimension.device.table.deviceId': 'Device ID',
  'riskDimension.device.table.totalMembers': 'Total Members',
  'riskDimension.device.table.riskMembers': 'Risk Members',
  'riskDimension.device.table.details': 'Details',
  'riskDimension.device.table.lastUpdateTime': 'Last Update',
  'riskDimension.device.table.action': 'Action',
  'riskDimension.device.table.view': 'View',
  'riskDimension.device.table.more': 'More',
  'riskDimension.device.table.total': 'Total {total} records',
  'riskDimension.device.detail.title': 'Device ID',
  'riskDimension.device.detail.summary': 'Total {total} users, {risk} with risk control',
  'riskDimension.device.detail.batchSetRisk': 'Batch Set Risk Level',
  'riskDimension.device.detail.searchPlaceholder': 'Search username',
  'riskDimension.device.detail.search': 'Search',
  'riskDimension.device.detail.memberAccount': 'Username',
  'riskDimension.device.detail.currentRisk': 'Current Risk',
  'riskDimension.device.detail.setRiskLevel': 'Set Risk Level',
  'riskDimension.device.detail.selectMembersFirst': 'Please select members first',
  'riskDimension.device.quickView.title': 'Associated Users',
  'riskDimension.device.quickView.deviceLabel': 'Device ID',
  'riskDimension.device.quickView.searchPlaceholder': 'Search account',
  'riskDimension.device.quickView.noResults': 'No accounts found',
  'riskDimension.device.quickView.showing': 'Showing',
  
  // Same Bank Card User Warning
  'riskDimension.bank.title': 'Same Bank Card User Warning',
  'riskDimension.bank.bankCard': 'Bank Card Number',
  'riskDimension.bank.bankCardPlaceholder': 'Enter bank card number',
  'riskDimension.bank.bankAccountName': 'Bank Account Name',
  'riskDimension.bank.bankAccountNamePlaceholder': 'Enter bank account name',
  'riskDimension.bank.memberAccount': 'Username',
  'riskDimension.bank.memberAccountPlaceholder': 'Enter username',
  'riskDimension.bank.minMemberCount': 'Min Associated Count ≥',
  'riskDimension.bank.minMemberCountPlaceholder': 'Enter',
  'riskDimension.bank.minRiskCount': 'Min Risk Count ≥',
  'riskDimension.bank.minRiskCountPlaceholder': 'Enter',
  'riskDimension.bank.query': 'Search',
  'riskDimension.bank.reset': 'Reset',
  'riskDimension.bank.export': 'Export',
  'riskDimension.bank.table.bankCard': 'Bank Card Number',
  'riskDimension.bank.table.bankAccountName': 'Bank Account Name',
  'riskDimension.bank.table.totalMembers': 'Total Members',
  'riskDimension.bank.table.riskMembers': 'Risk Members',
  'riskDimension.bank.table.details': 'Details',
  'riskDimension.bank.table.lastUpdateTime': 'Last Update',
  'riskDimension.bank.table.action': 'Action',
  'riskDimension.bank.table.view': 'View',
  'riskDimension.bank.table.more': 'More',
  'riskDimension.bank.table.total': 'Total {total} records',
  'riskDimension.bank.detail.title': 'Bank Card Number',
  'riskDimension.bank.detail.summary': 'Total {total} users, {risk} with risk control',
  'riskDimension.bank.detail.batchSetRisk': 'Batch Set Risk Level',
  'riskDimension.bank.detail.searchPlaceholder': 'Search username',
  'riskDimension.bank.detail.search': 'Search',
  'riskDimension.bank.detail.memberAccount': 'Username',
  'riskDimension.bank.detail.currentRisk': 'Current Risk',
  'riskDimension.bank.detail.setRiskLevel': 'Set Risk Level',
  'riskDimension.bank.detail.selectMembersFirst': 'Please select members first',
  'riskDimension.bank.quickView.title': 'Associated Users',
  'riskDimension.bank.quickView.bankCardLabel': 'Bank Card Number',
  'riskDimension.bank.quickView.searchPlaceholder': 'Search account',
  'riskDimension.bank.quickView.noResults': 'No accounts found',
  'riskDimension.bank.quickView.showing': 'Showing',
  
  // Same Wallet User Warning
  'riskDimension.wallet.title': 'Same Wallet User Warning',
  'riskDimension.wallet.walletNumber': 'Wallet Number',
  'riskDimension.wallet.walletNumberPlaceholder': 'Enter wallet number',
  'riskDimension.wallet.walletType': 'Wallet Type',
  'riskDimension.wallet.walletTypePlaceholder': 'Select wallet type',
  'riskDimension.wallet.walletType.USDT': 'USDT',
  'riskDimension.wallet.walletType.BTC': 'BTC',
  'riskDimension.wallet.walletType.ETH': 'ETH',
  'riskDimension.wallet.walletType.OTHER': 'Other',
  'riskDimension.wallet.memberAccount': 'Username',
  'riskDimension.wallet.memberAccountPlaceholder': 'Enter username',
  'riskDimension.wallet.minMemberCount': 'Min Associated Count ≥',
  'riskDimension.wallet.minMemberCountPlaceholder': 'Enter',
  'riskDimension.wallet.minRiskCount': 'Min Risk Count ≥',
  'riskDimension.wallet.minRiskCountPlaceholder': 'Enter',
  'riskDimension.wallet.query': 'Search',
  'riskDimension.wallet.reset': 'Reset',
  'riskDimension.wallet.export': 'Export',
  'riskDimension.wallet.table.walletNumber': 'Wallet Number',
  'riskDimension.wallet.table.walletType': 'Wallet Type',
  'riskDimension.wallet.table.totalMembers': 'Total Members',
  'riskDimension.wallet.table.riskMembers': 'Risk Members',
  'riskDimension.wallet.table.details': 'Details',
  'riskDimension.wallet.table.lastUpdateTime': 'Last Update',
  'riskDimension.wallet.table.action': 'Action',
  'riskDimension.wallet.table.view': 'View',
  'riskDimension.wallet.table.more': 'More',
  'riskDimension.wallet.table.total': 'Total {total} records',
  'riskDimension.wallet.detail.title': 'Wallet Number',
  'riskDimension.wallet.detail.summary': 'Total {total} users, {risk} with risk control',
  'riskDimension.wallet.detail.batchSetRisk': 'Batch Set Risk Level',
  'riskDimension.wallet.detail.searchPlaceholder': 'Search username',
  'riskDimension.wallet.detail.search': 'Search',
  'riskDimension.wallet.detail.memberAccount': 'Username',
  'riskDimension.wallet.detail.currentRisk': 'Current Risk',
  'riskDimension.wallet.detail.setRiskLevel': 'Set Risk Level',
  'riskDimension.wallet.detail.selectMembersFirst': 'Please select members first',
  'riskDimension.wallet.quickView.title': 'Associated Users',
  'riskDimension.wallet.quickView.walletNumberLabel': 'Wallet Number',
  'riskDimension.wallet.quickView.searchPlaceholder': 'Search account',
  'riskDimension.wallet.quickView.noResults': 'No accounts found',
  'riskDimension.wallet.quickView.showing': 'Showing',
};

